import React, { useState } from 'react';
import { Icon, Link } from '../../../../../ui-kit';

const InvoiceButton = ({
  invoiceId,
  getPaymentInvoice



}) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!invoiceId) return null;

  const onInvoiceClick = async () => {
    setIsLoading(true);
    const { data, error } = await getPaymentInvoice({
      invoiceId,
      isUrl: true
    });

    setIsLoading(false);
    if (error || !data || !data.getPaymentInvoice) return;

    const { invoiceUrl } = data.getPaymentInvoice?.[0];

    if (!invoiceUrl) return;

    window.open(invoiceUrl);
  };

  if (isLoading) {
    return <Icon name="sync2" color="nevada" spin />;
  }

  return (
    <Link onClick={onInvoiceClick}>
      {invoiceId}
    </Link>);

};

export default InvoiceButton;